/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorRow as ResolvedLabradorRow } from 'base/components/labrador/Row';

export const LabradorRow: typeof ResolvedLabradorRow = withLabradorInstanceof((props) => {
    return <ResolvedLabradorRow {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorRowProps = PropsFromComponent<typeof LabradorRow>;
